import { gql } from '@apollo/client';
import { store } from '../../../redux/store';
import featureFlags from '../../featureFlags';

const COMPANIES_WITH_CONTACT_NAME_FIELD = [
  // Thread help
  '248d6c67-713d-44ed-8c73-def5de1b80db',
  // CloudStep
  '252d5f12-40f3-4809-8f5c-bad72596ec4d',
  // Thread Stage Slack
  '2ad0a3b9-8c6c-4056-bd59-74bf42c439e4'
];

export const CORE_THREAD_FIELDS = () => {
  const { appId: companyAppId, featureFlags: availableFeatureFlags = [] } =
    store.getState()?.users?.user || {};
  const shouldIncludeContactName = COMPANIES_WITH_CONTACT_NAME_FIELD.includes(companyAppId);
  const isPlannerEnabled = availableFeatureFlags.includes(featureFlags.PLANNER);

  return gql`
    fragment CoreThreadFields on Thread {
      id
      system_id
      number
      created_at
      updated_at
      company_id
      member_id
      contact_id
      ${shouldIncludeContactName ? 'contact_name' : ''}
      summary
      state
      assignee
      email_alert
      conversation_source_id
      url
      link_type
      children_count
      notifications_count
      ${isPlannerEnabled ? 'nearest_schedule_date' : ''}
      swarm_timer {
        state
        initiated_at
        created_at
      }
      last_note {
        id
        text
        user_type
        sender_fullname
      }
      conversation_channel {
        name
        id
        friendly_name
      }
      internal_conversation_channel {
        name
        id
        friendly_name
      }
      status_object {
        id
        name
        closed_status
        is_default
      }
      contact {
        id
        email
        company {
          id
          name
        }
        user {
          phone
          fullname
        }
      }
      priority {
        id
        name
        color
      }
      board {
        id
        name
      }
      board_type {
        id
        name
      }
      board_sub_type {
        id
        name
      }
      board_item {
        id
        name
      }
      contacts {
        id
        name
      }
      members {
        id
        name
      }
      company_site {
        id
        name
      }
      agreement {
        id
        name
        type {
          id
          name
        }
      }
      ticket_type {
        id
        name
      }
      service_level_agreement {
        id
        name
        first_response_due_at
        resolution_due_at
        first_responded_at
        resolved_at
      }
      category {
        id
        name
      }
    }
  `;
};

export const PLANNER_THREAD_FIELDS = gql`
  fragment PlannerThreadFields on Thread {
    id
    summary
    number
    system_id
    status_object {
      id
      name
      closed_status
      is_default
    }
    priority {
      id
      name
      color
    }
    board {
      id
      name
    }
    contact {
      id
      email
      company {
        id
        name
      }
      user {
        phone
        fullname
      }
    }
    priority {
      id
      name
      color
    }
    company_id
    last_note {
      id
      text
      user_type
      sender_fullname
    }
    member_id
    assignee
    created_at
    updated_at
  }
`;
